import axios from 'axios';
import { store } from '../store/store';
import { buildFormState } from './createNewPacket';
import * as Sentry from '@sentry/react';

export default async ({ dataAPI, tag, formId, packetId, packetNid }) => {
	const { webforms } = store.getState();
	const formDefinition = webforms.forms.find(({ id }) => id === formId);
	const formData = buildFormState(formDefinition, dataAPI);

	const form = {
		packet_id: packetId,
		packet_nid: packetNid,
		packet_tag: tag,
		form_id: formDefinition.id,
		form_title: formDefinition.title,
		form_data: formData,
		form_definition: formDefinition
	};

	return axios
		.post('/forms_rest_api/form', form, { headers: { 'Content-Type': 'application/json' } })
		.then(({ data }) => data)
		.catch(error => {
			Sentry.captureException(error);
			throw error;
		});
};
